import React, { useId } from "react";

/** Labelled text input. */
export function TextField({ label, hint, className = "", ...props }) {
  const id = useId();
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}
      <input id={id} type="text" className="control" {...props} />
      {hint && <p className="mt-1 text-micro text-ink-500">{hint}</p>}
    </div>
  );
}

/** Labelled select. `options` is [{ value, label }]. */
export function SelectField({ label, options = [], className = "", ...props }) {
  const id = useId();
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}
      <select id={id} className="control appearance-none bg-white pr-8" {...props}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

/** Labelled date input. */
export function DateField({ label, className = "", ...props }) {
  const id = useId();
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}
      <input id={id} type="date" className="control" {...props} />
    </div>
  );
}
